import styled from 'styled-components'

export const ContentContainer = styled.div`
  padding: 32px;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 16px;
  }
`

export const AnalysisSectionTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 24px;
  text-transform: capitalize;
`

export const PlaceholderContent = styled.div`
  background: white;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  padding: 48px;
  text-align: center;
  color: #999;
  font-size: 14px;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
`

export const PlaceholderIcon = styled.div`
  font-size: 48px;
  opacity: 0.5;
`
